import { render, staticRenderFns } from "./ChangePasswordClientModal.vue?vue&type=template&id=5cf7bb95&scoped=true&lang=pug&"
import script from "./ChangePasswordClientModal.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordClientModal.vue?vue&type=script&lang=js&"
import style0 from "./ChangePasswordClientModal.vue?vue&type=style&index=0&id=5cf7bb95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf7bb95",
  null
  
)

export default component.exports